import { render, staticRenderFns } from "./DaigouCreate.vue?vue&type=template&id=0ecc3aee&scoped=true"
import script from "./DaigouCreate.vue?vue&type=script&lang=js"
export * from "./DaigouCreate.vue?vue&type=script&lang=js"
import style0 from "./DaigouCreate.vue?vue&type=style&index=0&id=0ecc3aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc3aee",
  null
  
)

export default component.exports